import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from './Filters.types'

enum Keys {
  Y = 'Yes',
  N = 'No',
}

interface IsLTRFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

const _IsLTRFilter: FC<IsLTRFilterProps> = props => {
  const options = Object.keys(Keys).map(key => ({
    value: key,
    hasFullWidth: true,
    label: Keys[key as keyof typeof Keys],
  }))

  return <CheckboxBasedFilter title="Is LTR Only?" options={options} {...props} />
}

export const IsLTRFilter = observer(_IsLTRFilter)
